import { FC, memo } from 'react'
import { TMessageGroup } from './types'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../components/Typography'
import MessageItem from './MessageItem'
import '../styles.scss'
import { ILRenderItem } from '../../../../components/InfiniteList/InfiniteList'
import { checkIsToday } from '../../../../helper/dates'
import { timelineDateFormat } from '../../../../components/Timelines/constants'

const MessagesGroup: FC<ILRenderItem<TMessageGroup>> = (props) => {
  const { item } = props
  const [label, chatHistory] = item
  const isAuthorBlock = (idx) => {
    return (
      chatHistory[idx]?.message.created_at?.slice(0, -4) !==
        chatHistory[idx - 1]?.message.created_at?.slice(0, -4) ||
      chatHistory[idx]?.message.author?.uuid !==
        chatHistory[idx - 1]?.message.author?.uuid
    )
  }
  return (
    <div className="messages-wrapper-group" key={label + chatHistory.length}>
      <Typography.Label
        weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
        className="messages-wrapper-group__time"
      >
        {checkIsToday(label, timelineDateFormat) ? 'Today' : label}
      </Typography.Label>
      {chatHistory.map((message, idx, messagesList) => {
        let unreadLabel = <></>
        if (message.firstUnread) {
          unreadLabel = (
            <Typography.Label
              weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
              className="messages-wrapper-group__unread-marker"
            >
              {messagesList.length - idx - 1 > 1
                ? 'Unread messages'
                : 'Unread message'}
              <div className="unread-marker" />
            </Typography.Label>
          )
        }
        return (
          <>
            {unreadLabel}
            <MessageItem
              {...message}
              key={message.message.uuid}
              isAuthorBlock={isAuthorBlock(idx)}
            />
          </>
        )
      })}
    </div>
  )
}

const arePropsEqual = (
  pProps: ILRenderItem<TMessageGroup>,
  nProps: ILRenderItem<TMessageGroup>
) => {
  const [pLabel, pHistory] = pProps.item
  const [nLabel, nHistory] = nProps.item

  if (pLabel !== nLabel || pHistory.length !== nHistory.length) return false

  return pHistory.every(
    (msg, index) =>
      msg.read_by_members === nHistory[index].read_by_members &&
      msg.firstUnread === nHistory[index].firstUnread
  )
}

export default memo(MessagesGroup, arePropsEqual)
